// extracted by mini-css-extract-plugin
export default {"uploadError":"paoPGa0zYyHrxCnuxMns"};